/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_Rights_ReservedInputs */

const en_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. All rights reserved.`)
};

const es_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Todos los derechos reservados.`)
};

const fr_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Tous droits réservés.`)
};

const de_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Alle Rechte vorbehalten.`)
};

const ja_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. All rights reserved.`)
};

const zh_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. 保留所有权利。`)
};

const ar_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. جميع الحقوق محفوظة.`)
};

const id_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Hak cipta dilindungi undang-undang.`)
};

const it_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Tutti i diritti riservati.`)
};

const ru_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Все права защищены.`)
};

const pt_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Todos os direitos reservados.`)
};

const ko_all_rights_reserved = /** @type {(inputs: All_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. All rights reserved.`)
};

/**
* | output |
* | --- |
* | ". All rights reserved." |
*
* @param {All_Rights_ReservedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const all_rights_reserved = /** @type {((inputs?: All_Rights_ReservedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_Rights_ReservedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_all_rights_reserved(inputs)
	if (locale === "es") return es_all_rights_reserved(inputs)
	if (locale === "fr") return fr_all_rights_reserved(inputs)
	if (locale === "de") return de_all_rights_reserved(inputs)
	if (locale === "ja") return ja_all_rights_reserved(inputs)
	if (locale === "zh") return zh_all_rights_reserved(inputs)
	if (locale === "ar") return ar_all_rights_reserved(inputs)
	if (locale === "id") return id_all_rights_reserved(inputs)
	if (locale === "it") return it_all_rights_reserved(inputs)
	if (locale === "ru") return ru_all_rights_reserved(inputs)
	if (locale === "pt") return pt_all_rights_reserved(inputs)
	return ko_all_rights_reserved(inputs)
});